<script>

export default {
  name: "emailUsSectionDark",
  data() {
    return {
      unfold: false,
      value1: true,
      theme: "dark",
      switchColor: "#2D2D2D"
    };
  },
  components: {
  }
};
</script>

<template>
  <el-row>
    <el-col :span="24" class="email-us-wrapper">
      If you have any questions, feel free to email us | team@unifiproperty.com
    </el-col>
  </el-row>
</template>

<style scoped>
.email-us-wrapper{
  display: flex;
  justify-content: center;
  color: #fff;
  background-color: #003333;
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  align-self: stretch;
  font: 400 30px DINosaur-a, sans-serif;
  padding: 12px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/contact/emailUsSectionDark.vue